<template>
    <div>
        <div class="assets-title">
            <div style="display: flex; align-items: center">
                <div class="title-line"></div>
                <span class="title-content">我的资产</span>
                <span class="deadline-text">截止日期 {{ date }}</span>
            </div>
            <div style="display: flex; align-items: center">
                <el-select v-model="sourceflag" placeholder="选择购买渠道" class="select-class">
                    <el-option
                        v-for="item in sourceflags"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
                <div class="assets-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入基金代码/名称"
                        class="input-search"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="suffix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="searchAssets"
                        />
                    </el-autocomplete>
                </div>
                <a
                    v-if="showAssetProofDownload"
                    class="asset-proof-button second-button"
                    href="javascript:;"
                    v-on:click="handleDownload"
                >
                    下载资产证明
                </a>
            </div>
        </div>
        <!-- 资产总览卡片 -->
        <AssetsOverviewCard
            :amount-type="amountType"
            :assets="assets"
            :xjb-fund-info="xjbFundInfo"
            :data-prompt-show="dataPromptShow"
            :showprofitexplain="showprofitexplain"
            :hide-asset-profit="hideAssetProfit"
        />
        <div v-if="assets.length > 0 && hasLoad && selectIndex != 3" class="holding-title">
            <div class="title-line"></div>
            <span class="title-content">公募基金持仓</span>
        </div>
        <div
            v-if="warnNum > 0 && $util.getConfig().hideFunc && !$util.isWebQueryMode()"
            class="warn-info"
        >
            <i class="el-icon-warning warn-icon" aria-hidden="true" />
            <span class="warn-content">
                由于您的个人风险等级或产品风险等级变动，存在({{
                    warnNum
                }})笔产品风险等级高于您的风险承受能力的交易，请阅读风险警示进行适当性处理。
                <span v-if="showSuitablePlanWarnTip" class="warn-tip">
                    对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。
                </span>
                <span class="deal-btn" v-on:click="toWarnDetail">前往处理</span>
            </span>
        </div>
        <!-- <div class="asset-type">
            <div
                v-for="(item, index) in assetsTypes"
                :key="index"
                :class="selectIndex == index ? 'type-select' : 'type-normal'"
                v-on:click="selectType(index)"
            >
                {{ item }}
            </div>
        </div> -->
        <el-table
            v-if="assets.length > 0 && hasLoad && selectIndex != 3"
            :data="assets"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
            v-on:sort-change="handleSortChange"
        >
            <el-table-column label="产品名称" width="200" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        <el-tooltip effect="info" :content="scope.row.fundname" placement="top">
                            <span>
                                {{ scope.row.fundname }}
                                <span v-if="scope.row.assetshowtype == '1'" class="xjbStyle">
                                    {{ $const.getXJBParam("name") }}
                                </span>
                            </span>
                        </el-tooltip>
                    </div>
                    <div style="display: flex; align-items: center">
                        <div>{{ scope.row.fundcode }}</div>
                        <div v-if="$util.hasFM(scope.row)" class="fm1">浮动管理费基金</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="nav"
                label="最新净值"
                width="110"
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <div>{{ $util.fmtNum(scope.row.nav, 4) || "--" }}</div>
                    <div style="color: #999; font-size: 12px">
                        {{ scope.row.navdate ? $util.fmtDate(scope.row.navdate) : "" }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="currentshare"
                label="持有份额(份)"
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="marketvalue" align="center" sortable="custom">
                <template slot="header">
                    <span>
                        {{
                            $cache.getCompanyInfoParam("5100004") == "1"
                                ? "市值(元)"
                                : "持仓市值(元)"
                        }}
                    </span>
                    <el-tooltip
                        v-if="$cache.getCompanyInfoParam('5100004') == '1'"
                        effect="dark"
                        content="市值=持仓市值+在途金额"
                        placement="top-start"
                    >
                        <i
                            class="el-icon-info"
                            style="margin-left: 5px; color: var(--color-text-accent)"
                        ></i>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!hideAssetProfit"
                prop="lastprofit"
                label="昨日收益(元)"
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.lastprofit > 0
                                ? 'add'
                                : scope.row.lastprofit < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ $util.fmtNum(scope.row.lastprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!hideAssetProfit"
                prop="currentprofit"
                label="持仓收益"
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="getProfitClass(scope.row)">
                        {{ getProfitText(scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!hideAssetProfit && !hideAssetIncome"
                prop="currentprofitrate"
                label="持仓收益率"
                width="120"
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="getProfitClass(scope.row)">
                        {{ getProfitRateText(scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180">
                <template slot-scope="scope">
                    <div v-if="$util.getConfig().hideFunc && !$util.isWebQueryMode()" class="btns">
                        <el-tooltip
                            v-if="
                                (scope.row.assetshowtype === '1' ||
                                    xjbFundInfo.fundcode !== scope.row.fundcode) &&
                                scope.row.isBuy
                            "
                            class="item"
                            effect="info"
                            :content="
                                scope.row.isBuy +
                                '，不能' +
                                (scope.row.assetshowtype == '1'
                                    ? '充值'
                                    : scope.row.status == '1'
                                    ? '认购'
                                    : '申购')
                            "
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">
                                {{
                                    scope.row.assetshowtype == "1"
                                        ? "充值"
                                        : scope.row.status == "1"
                                        ? "认购"
                                        : "申购"
                                }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else-if="
                                scope.row.assetshowtype === '1' ||
                                xjbFundInfo.fundcode !== scope.row.fundcode
                            "
                            type="text"
                            plain
                            size="small"
                            :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{
                                scope.row.assetshowtype == "1"
                                    ? "充值"
                                    : scope.row.status == "1"
                                    ? "认购"
                                    : "申购"
                            }}
                        </el-button>
                        <div
                            v-if="
                                scope.row.assetshowtype === '1' ||
                                xjbFundInfo.fundcode !== scope.row.fundcode
                            "
                            class="line"
                        ></div>
                        <el-tooltip
                            v-if="scope.row.isSell"
                            class="item"
                            effect="info"
                            :content="scope.row.isSell"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">
                                {{
                                    scope.row.assetshowtype == "1"
                                        ? "取现"
                                        : scope.row.bookingredeem == "1" ||
                                          scope.row.bookingredeem == "2"
                                        ? "预约赎回"
                                        : "赎回"
                                }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else-if="
                                scope.row.bookingredeem == '1' || scope.row.bookingredeem == '2'
                            "
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('25', scope.row)"
                        >
                            预约赎回
                        </el-button>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            :disabled="
                                xjbFundInfo.fundcode === scope.row.fundcode &&
                                Number(scope.row.usableremainshare) <= 0
                            "
                            v-on:click.stop="callbackFn('24', scope.row)"
                        >
                            {{ xjbFundInfo.fundcode !== scope.row.fundcode ? "赎回" : "取现" }}
                        </el-button>
                        <!-- <div v-if="scope.row.sourceflag != '2'" class="line"></div> -->
                        <div class="line"></div>
                        <!-- <div v-if="!(scope.row.fundArr.every((item) => item.sourceflag === '2'))" class="line"></div> -->
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                    <div v-else>
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0 && selectIndex != 3" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newAssets"
            />
        </el-row>
        <!-- 首页底部 Banner -->
        <home-banner v-if="selectIndex != 3"></home-banner>
        <combo-assets v-show="selectIndex == 3" ref="comboAssets" :showhead="false"></combo-assets>
        <my-dialog
            v-if="!$util.isWebQueryMode()"
            title="提示"
            :visible.sync="warnVisible"
            :dialog-close="dialogClose"
            width="600px"
            :show-close="showclose"
        >
            <div class="warn-detail">
                由于您的个人风险等级或产品风险等级变动，存在({{
                    warnNum
                }})笔产品风险等级高于您的风险承受能力的交易，请前往进行适当性处理。
            </div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="toWarnDetail">
                    确认
                </el-button>
            </div>
        </my-dialog>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
        <my-dialog
            title="提示"
            :visible.sync="bankCardVisible"
            :dialog-close="bankCardListClose"
            width="600px"
        >
            <div class="warn-detail">
                您所持有的银行卡有{{
                    bankCardNum
                }}张正处于“待激活"状态，为了使您的交易不受影响，点击确认，一键完成“激活”。
            </div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="bankCardListHandle">
                    确认
                </el-button>
            </div>
        </my-dialog>
        <my-dialog
            title="提示"
            :visible.sync="idCardHolderVisible"
            :dialog-close="idCardHolderClose"
            :show-close="false"
            width="600px"
        >
            <div class="warn-detail">
                尊敬的客户：您在系统中的身份证号为15位，
                <br />
                为保证您的正常使用请升级为18位！
            </div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="idCardHolderHandle">
                    确认
                </el-button>
            </div>
        </my-dialog>
        <my-dialog
            title="提示"
            :visible.sync="idCardHolderUnsupportedVisible"
            :dialog-close="idCardHolderUnsupportedClose"
            :show-close="false"
            width="600px"
        >
            <div class="warn-detail">
                {{ idCardHolderUnsupportedText }}
            </div>
            <div class="align-c">
                <el-button
                    type="primary"
                    style="width: 180px"
                    v-on:click="idCardHolderUnsupportedClose"
                >
                    确定
                </el-button>
            </div>
        </my-dialog>
        <my-dialog
            title="提示"
            :visible.sync="idCardHolderCompletedVisible"
            :dialog-close="idCardHolderCompletedClose"
            width="600px"
        >
            <div class="warn-detail">
                尊敬的用户您好：您已成功升级身份证，请确保银行卡绑定身份证与系统身份证位数一致，否则无法进行交易！
            </div>
            <div class="align-c">
                <el-button
                    type="primary"
                    style="width: 180px"
                    v-on:click="idCardHolderCompletedHandle"
                >
                    确认
                </el-button>
            </div>
        </my-dialog>

        <my-dialog
            title="提示"
            :visible.sync="appropriateHandlingVisible"
            :dialog-close="appropriateHandlingVisibleClose"
            :show-close="showclose"
            width="800px"
        >
            <warn-list
                :title-visible="false"
                :show-close="showclose"
                v-on:read-risk-all="appropriateHandlingVisibleClose"
                v-on:close-dialog="handleCloseDialog"
            />
        </my-dialog>
        <ocr-upd-dialog
            :visible="ocrShow"
            :cert-type="'00'"
            :checkflag="'0'"
            v-on="{ success: imgUp, back: regression }"
        />
        <dalogChild
            width="520px"
            :dialog-visible.sync="showDialog"
            :copywriting-display="certDialogCopywritingDisplay"
            v-on:cancel="handleCertDialogClosed"
            v-on:confirm="handleCertDialogClosed"
        ></dalogChild>
        <my-dialog
            class="my-dialog-contain"
            title="请输入交易密码"
            :visible="pwdDialogVisible"
            width="620px"
            :dialog-close="closePwdDialog"
        >
            <div class="acct-con">
                <el-form
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item prop="tradepassword" label="交易密码：" class="form-text">
                        <el-input
                            v-model.trim="pwdForm.tradepassword"
                            type="password"
                            show-password
                            maxlength="16"
                            placeholder="请输入交易密码"
                            class="input-pwd"
                            autocomplete="new-password"
                        />
                    </el-form-item>
                    <el-form-item>
                        <div class="btn-contain">
                            <button class="confirm-btn" v-on:click="submitPwdForm">确定</button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </my-dialog>
        <my-dialog
            class="my-dialog-contain"
            title="暂无法生成资产证明"
            :visible="noAssetDialogVisible"
            width="550px"
            :dialog-close="closeNoAssetDialog"
        >
            <div class="no-asset-content">
                <p>截至当前查询时间，您的账户暂无基金持仓，暂无法生成资产证明。</p>
            </div>
            <div class="noAssetDialogVisible-footer">
                <el-button type="primary" v-on:click="closeNoAssetDialog">确定</el-button>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import commonApi from "@/api/common";
import urls from "@/api/urls";
import format from "date-fns/format";
import myDialog from "@/components/layout/myDialog.vue";
import comboAssets from "@/components/fund/comboAssets.vue";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import WarnList from "@/bizcomponents/assetShow/warnList.vue";
import ocrUpdDialog from "@/components/form/ocrUpdDialog.vue";
import dalogChild from "@/components/acctInfo/dalogChild.vue";
import homeBanner from "@/components/fund/homeBanner.vue";
import { getHomePopupQueue } from "@/util/homePopupQueue";
import AssetsOverviewCard from "@/components/fund/assetsOverviewCard.vue";

export default {
    name: "MyAssets",
    components: {
        WarnList,
        myDialog,
        comboAssets,
        fundSdxDialog,
        ocrUpdDialog,
        dalogChild,
        homeBanner,
        AssetsOverviewCard
    },
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            searchText: "", // 搜索文本内容
            allAssets: {}, // 资产汇总信息
            assets: [], // 资产列表
            warnNum: 0, // 待处理数量
            warnVisible: false, // 适当性弹窗是否显示
            // =========================
            // 首页引导弹窗队列（Promise resolve 通知）
            // =========================
            queueResolveStep3: null, // 适当性处理提醒
            queueResolveStep4: null, // 银行卡待激活
            queueResolveStep5: null, // 身份证升位提示
            queueResolveStep6: null, // OCR上传证件
            queueResolveStep7: null, // 身份证升位完成

            // step shouldShow 计算结果（不直接弹窗，等待队列 show）
            shouldShowSuitable: false,
            suitableListPromise: Promise.resolve(false),
            shouldShowBankCard: false,
            bankCardListPromise: Promise.resolve(false),
            shouldShowIdCardHolder: false,

            // 身份证升位链路内部状态（direct / ocr / unsupported）
            idUpgradePath: "", // 'direct' | 'ocr' | 'unsupported'
            idUpgradeOcrRequired: false,
            idUpgradeOcrSuccess: false,
            idUpgradeCompletedInQueue: false,
            ocrProcessing: false,

            // 证件弹窗状态（区分队列引导与交易拦截场景）
            certDialogResolver: null, // 队列 resolve 回调
            certDialogType: "", // 'queue' | 'callback' | ''
            certDialogCopywritingDisplay: true, // 默认显示交易限制文案

            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            sortField: "", // 排序字段
            sortOrder: "", // 排序方向 "" 不排序 "ascending" 升序 "descending" 降序
            amountType: {
                totalAsset: "", // 总资产
                generalAsset: "", // 基金资产
                xjbMarketvalue: "", // 现金宝资产
                lastprofit: "", // 昨日收益
                totalProfit: "", // 累计收益
                currentprofit: "", // 持仓收益
                specialasset: "" // 专户资产
            },
            assetsTypes: ["全部", this.$const.getXJBParam("name"), "基金资产", "资产组合"],
            sourceflag: null, // 购买渠道
            sourceflags: [
                {
                    label: "全部购买渠道",
                    value: ""
                },
                {
                    label: "直销",
                    value: "1"
                },
                {
                    label: "代销",
                    value: "2"
                }
            ], // 购买渠道列表
            selectIndex: 0, // 选中资产类型下标
            curPage: 1, // 当前页
            date: "", // 当前日期
            hasLoad: false, // 是否已经查询数据
            assetshowtype: 0,
            sdxFundInfo: {},
            sdxDialogVisible: false,
            // 银行卡
            bankCardVisible: false,
            bankCardNum: 0,
            // 身份证生位
            idCardHolderVisible: false,
            idCardHolderUnsupportedVisible: false,
            // 身份证生位完成
            idCardHolderCompletedVisible: false,
            xjbFundInfo: {},
            appropriateHandlingVisible: false,
            dataPromptShow: false, // 收益字段旁提示
            ocrShow: false,
            isShowPositionProfit: true, // 货币基金是否展示持仓收益
            showclose: true, // 是否展示风险不匹配弹框关闭按钮，默认开启
            showprofitexplain: true, // 脚本控制是否显示小问号
            hideAssetProfit: false, // 是否隐藏资产收益展示
            hideAssetIncome: false, // 是否隐藏持仓收益率列
            showDialog: false, // 控制对话框显示状态
            downLoadUrl: "", // 下载资产证明url
            pwdDialogVisible: false, // 交易密码弹窗
            noAssetDialogVisible: false, // 无资产提示弹窗
            pwdForm: {
                tradepassword: ""
            },
            rules: {
                tradepassword: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            }
        };
    },
    computed: {
        showAssetProofDownload() {
            const userInfo = this.$cache.getUser();
            const assetInfo = this.$cache.getParamValue("asset_info");
            const assetProofDownloadEnable =
                assetInfo && assetInfo.asset_proof_download_enable == true;
            const isPureRegisteredUser = userInfo && userInfo.custbelongto === "2";

            return (
                this.$util.getConfig().hideFunc &&
                assetProofDownloadEnable &&
                (isPureRegisteredUser || this.$cache.getBinded())
            );
        },
        showSuitablePlanWarnTip() {
            return this.getRiskMismatchAgreementSwitch() !== "0";
        },
        idCardHolderUnsupportedText() {
            const servicePhone = this.$cache.getCompanyInfoParam("10101009") || "";
            return servicePhone
                ? `您的证件暂不支持线上更新，详情请联系客服(${servicePhone})`
                : "您的证件暂不支持线上更新，详情请联系客服";
        }
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchAssets();
            }
        },
        sourceflag(val, from) {
            this.pageoffset = 1;
            this.doAction();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        this.downLoadUrl =
            this.$util.fileUploadPath(urls.assetsPdf) + "?token=" + this.$cache.getSessionToken();

        const accountInfo = this.$cache.getParamValue("account_info");
        let risk = accountInfo && accountInfo.promptoptions && accountInfo.promptoptions.risk;

        if (risk && risk.showclose !== undefined) {
            this.showclose = risk.showclose;
        }

        const assetInfo = this.$cache.getParamValue("asset_info");
        this.showprofitexplain = !(assetInfo && assetInfo.showprofitexplain === false);
        this.hideAssetProfit = !!(
            assetInfo &&
            (assetInfo.hide_asset_profit === true || assetInfo.hide_asset_profit === "true")
        );
        this.hideAssetIncome = !!(
            assetInfo &&
            (assetInfo.hide_asset_income === true || assetInfo.hide_asset_income === "true")
        );

        this.doAction();
        const queue = getHomePopupQueue();
        const isWebQueryMode = this.$util.isWebQueryMode();

        if (this.$cache.getBinded() && !isWebQueryMode) {
            this.suitableListPromise = this.getSuitableList();
            this.bankCardListPromise = this.$util.isPersonalBuyBusinessDisabled()
                ? Promise.resolve(false)
                : userApi
                      .getBankCardList()
                      .then(({ bankList }) => this.bankCardListCheck(bankList));
        } else {
            this.suitableListPromise = Promise.resolve(false);
            this.bankCardListPromise = Promise.resolve(false);
        }

        if (!isWebQueryMode) {
            this.idCardHolderCheck();
        }

        // --------------------------
        // 首页引导弹窗队列（第30~36步；路由迁入首页时的账户校验弹窗见 util.registerHomeDeferredAcctDialogs order 10~13）
        // --------------------------
        queue.addStep({
            id: "suitableHandle",
            order: 30,
            shouldShow: async () => {
                if (this.$util.isWebQueryMode()) return false;
                await this.suitableListPromise;
                // 绑定手机号拦截弹窗期间，避免与适当性处理弹窗重叠
                await this.waitForBindingMobileDialogToClose();
                return this.shouldShowSuitable;
            },
            show: async () => {
                // 再等待一次，防止绑定手机号弹窗在 shouldShow 之后才刚弹出
                await this.waitForBindingMobileDialogToClose();

                return new Promise((resolve) => {
                    this.queueResolveStep3 = resolve;
                    this.warnVisible = true;
                });
            }
        });

        queue.addStep({
            id: "bankActivation",
            order: 31,
            shouldShow: async () => {
                if (this.$util.isWebQueryMode()) return false;
                if (this.$util.isPersonalBuyBusinessDisabled()) return false;
                await this.bankCardListPromise;
                return this.shouldShowBankCard;
            },
            show: () =>
                new Promise((resolve) => {
                    this.queueResolveStep4 = resolve;
                    this.bankCardVisible = true;
                })
        });

        queue.addStep({
            id: "idUpgradePrompt",
            order: 33,
            shouldShow: async () => {
                if (this.$util.isWebQueryMode()) return false;
                return this.shouldShowIdCardHolder;
            },
            show: () =>
                new Promise((resolve) => {
                    this.queueResolveStep5 = resolve;
                    this.idCardHolderVisible = true;
                })
        });

        queue.addStep({
            id: "ocrUpload",
            order: 34,
            shouldShow: async () => {
                if (this.$util.isWebQueryMode()) return false;
                return this.idUpgradeOcrRequired;
            },
            show: () =>
                new Promise((resolve) => {
                    this.queueResolveStep6 = resolve;
                    this.ocrProcessing = false;
                    this.idUpgradeOcrSuccess = false;
                    this.ocrShow = true;
                })
        });

        queue.addStep({
            id: "idUpgradeCompleted",
            order: 35,
            shouldShow: async () => {
                if (this.$util.isWebQueryMode()) return false;
                // direct：升位直接走接口，完成弹窗必然需要展示（即使失败，show 内也会兜底不展示）
                if (this.idUpgradePath === "direct") return true;
                // ocr：只有 OCR 升位成功才展示完成弹窗
                return this.idUpgradeOcrSuccess;
            },
            show: async () => {
                // direct path：先把升位接口做完，再展示完成弹窗
                if (this.idUpgradePath === "direct") {
                    const ok = await this.performDirectIdUpgrade();
                    if (!ok) {
                        return;
                    }
                }

                return new Promise((resolve) => {
                    this.queueResolveStep7 = resolve;
                    this.idUpgradeCompletedInQueue = true;
                    this.idCardHolderCompletedVisible = true;
                });
            }
        });

        queue.addStep({
            id: "returnVisit",
            order: 36,
            shouldShow: async () => {
                if (this.$util.isWebQueryMode()) return false;
                if (!this.$cache.getCompanyInfoParam("10102036")) return false;
                if (sessionStorage.getItem("_showReturnVisit")) return false;

                // 投资者回访在身份证升位完成（或不需要升位）后再弹
                if (
                    this.idUpgradePath !== "unsupported" &&
                    !this.idUpgradeCompletedInQueue &&
                    this.isIdUpgradeNeeded()
                ) {
                    return false;
                }

                const res = await userApi.qryReturnVisitStatus();
                const status =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data[0] &&
                    res.data.data[0].returnvisitstatus;
                return status === "0";
            },
            show: async () => {
                sessionStorage.setItem("_showReturnVisit", "1");
                await this.showReturnVisitDialog();
            }
        });

        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};
        this.isShowPositionProfit = this.$util.isShowPositionProfit();
    },
    methods: {
        getRiskMismatchAgreementSwitch() {
            // 首页资产提示直接读取杂参 【投资者或产品风险等级变更导致风险不匹配，非最低风险承受能力投资者默认协议状态】 25071101：0-正常（不展示红字），其余值展示红字。
            const param = this.$cache.getParams("25071101");

            if (param && typeof param === "object") {
                return String(param.paramvalue || param.value || param.paramValue || "");
            }

            return String(param || "");
        },
        // 绑定手机号弹窗期间：等待其关闭，避免与适当性处理弹窗重叠
        waitForBindingMobileDialogToClose() {
            const maxWaitMs = 10000;
            const start = Date.now();
            return new Promise((resolve) => {
                const tick = () => {
                    const flag = sessionStorage.getItem("_bindingMobileDialog");
                    if (!flag) return resolve();
                    if (Date.now() - start > maxWaitMs) return resolve();
                    setTimeout(tick, 300);
                };
                tick();
            });
        },
        tracesLog() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.acct_download_file,
                eventname: `下载文件`,
                content: JSON.stringify({ name: "资产证明", url: this.downLoadUrl })
            });
        },
        // 点击下载资产证明：未开户引导开户；已开户按杂参 10105014 决定是否弹密码框；无资产时提示
        handleDownload() {
            if (!this.hasLoad) {
                this.$message.warning("资产数据加载中，请稍候...");
                return;
            }

            const totalAsset = this.allAssets && this.allAssets.totalasset;
            const hasTotalAsset = totalAsset && Number(totalAsset) > 0;
            if (!hasTotalAsset) {
                this.noAssetDialogVisible = true;
                return;
            }

            const needPwd = this.$cache.getCompanyInfoParam("10105014") === "1";
            if (needPwd) {
                if (!this.$cache.getBinded()) {
                    this.$belongToDialog();
                    return;
                }
                this.pwdForm.tradepassword = "";
                this.pwdDialogVisible = true;
            } else {
                this.tracesLog();
                window.open(this.downLoadUrl, "_blank");
            }
        },
        closePwdDialog() {
            this.pwdDialogVisible = false;
            this.pwdForm.tradepassword = "";
        },
        closeNoAssetDialog() {
            this.noAssetDialogVisible = false;
        },
        async submitPwdForm() {
            this.$refs.pwdForm.validate(async (valid) => {
                if (!valid) {
                    this.$errorScroll && this.$errorScroll();
                    return;
                }

                const pwdRes = await userApi.verifyTradePwd({
                    tradepassword: this.$util.enc(this.pwdForm.tradepassword),
                    biztype: "0"
                });
                if (pwdRes.code != 0) {
                    return;
                }

                this.tracesLog();
                window.open(this.downLoadUrl, "_blank");
                this.closePwdDialog();
            });
        },

        // 获取持仓收益样式类
        getProfitClass(row) {
            // 不显示持仓收益且为货币基金时，无样式
            if (!this.isShowPositionProfit && row.fundshowtype === "5") {
                return "";
            }
            // 其他情况根据收益值判断样式
            return row.currentprofit > 0 ? "add" : row.currentprofit < 0 ? "reduce" : "";
        },
        // 获取持仓收益显示文本
        getProfitText(row) {
            // 不显示持仓收益且为货币基金时，显示--
            if (!this.isShowPositionProfit && row.fundshowtype === "5") {
                return "--";
            }
            return this.$util.fmtNum(row.currentprofit);
        },
        // 获取持仓收益率显示文本
        getProfitRateText(row) {
            if (
                (!this.isShowPositionProfit && row.fundshowtype === "5") ||
                this.$util.isEmpty(row.currentprofitrate)
            ) {
                return "--";
            }
            return this.$util.fmtNum(row.currentprofitrate) + "%";
        },
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toFundDetailPage(val.fundcode);
        },
        // 获取待处理协议列表
        async getSuitableList() {
            // 网查模式只做查询展示，不拉取/展示登录后的适当性处理提示。
            if (this.$util.isWebQueryMode() || !this.$cache.getBinded()) {
                this.shouldShowSuitable = false;
                this.warnNum = 0;
                this.warnVisible = false;
                return false;
            }
            const res = await userApi.getSuitableList();
            if (res.data) {
                this.warnNum = res.data.total;
                this.$store.commit("updateSuitableList", res.data.data);
                const showWarn = sessionStorage.getItem("_showWarn");
                this.shouldShowSuitable =
                    this.warnNum > 0 &&
                    !showWarn &&
                    this.$cache.getUserOtherInfo().specialflag == "0" &&
                    this.$util.getConfig().hideFunc &&
                    !this.$util.isWebQueryMode();
                return this.shouldShowSuitable;
            }
            this.shouldShowSuitable = false;
            return false;
        },
        // 关闭警告弹窗
        dialogClose() {
            this.warnVisible = false;
            sessionStorage.setItem("_showWarn", "1");
            if (this.queueResolveStep3) {
                this.queueResolveStep3();
                this.queueResolveStep3 = null;
            }
        },
        // 跳转到待处理协议列表
        toWarnDetail() {
            if (this.showclose === false) {
                // showclose=false 时，不允许同时存在两个弹窗
                this.warnVisible = false;
                sessionStorage.setItem("_showWarn", "1");
                this.appropriateHandlingVisible = true;
            } else {
                this.warnVisible = false;
                sessionStorage.setItem("_showWarn", "1");
                if (this.queueResolveStep3) {
                    this.queueResolveStep3();
                    this.queueResolveStep3 = null;
                }
                this.$router.push("/warnList");
            }
        },
        // 获取新一页数据
        newAssets(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 表头排序
        handleSortChange({ prop, order }) {
            if (order) {
                this.sortField = prop;
                this.sortOrder = order;
            } else {
                this.sortField = "";
                this.sortOrder = "";
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getAssets(val, cb);
            }, 500);
        },
        // 获取资产信息
        async getAssets(val, cb) {
            if (!this.$cache.getBinded() && !this.$cache.getCustnoCrm()) {
                return;
            }
            // const _x = {
            //     keyword: val ? val : (this.searchText ? this.searchText : ""),
            //     pagesize: cb ? 20 : this.pagecount,
            //     pagenum: val ? 1 : this.pageoffset,
            // };
            const res = await fundApi.getAssetsList({
                producttype: "0",
                sourceflag: this.sourceflag ? this.sourceflag : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pageSize: cb ? 20 : this.pagecount,
                pageNum: val ? 1 : this.pageoffset,
                assetshowtype: this.assetshowtype,
                isasc: this.sortOrder ? (this.sortOrder === "ascending" ? "1" : "0") : "",
                orderfield: this.sortField || ""
            });
            this.hasLoad = true;
            if (res.data) {
                this.allAssets = res.data.first ? res.data.first : {};
                const array = res.data.returnList ? res.data.returnList : [];
                this.amountType = Object.assign(this.amountType, {
                    totalAsset: this.allAssets.totalasset,
                    lastprofit: this.allAssets.lastprofit,
                    totalProfit: this.allAssets.totalprofit,
                    currentprofit: this.allAssets.currentprofit,
                    generalAsset: this.allAssets.generalasset,
                    specialasset: this.allAssets.specialasset
                });

                // 优先按现金宝页口径取持仓市值，取不到时用资产汇总兜底
                let xjbMarketvalue = "";
                if (this.xjbFundInfo && this.xjbFundInfo.fundcode) {
                    const xjbFund = array.find(
                        (item) => item.fundcode === this.xjbFundInfo.fundcode
                    );
                    if (xjbFund && !this.$util.isEmpty(xjbFund.marketvalue)) {
                        xjbMarketvalue = xjbFund.marketvalue;
                    }
                }
                if (this.$util.isEmpty(xjbMarketvalue)) {
                    const xjbFund = array.find(
                        (item) => item.assetshowtype === "1" || item.assettype === "0"
                    );
                    if (xjbFund && !this.$util.isEmpty(xjbFund.marketvalue)) {
                        xjbMarketvalue = xjbFund.marketvalue;
                    }
                }
                this.amountType.xjbMarketvalue = this.$util.isEmpty(xjbMarketvalue)
                    ? this.allAssets.xjbasset
                    : xjbMarketvalue;
                // 批量获取基金详细信息，包括 tradingmethod 字段
                if (array && array.length > 0) {
                    const fundCodeList = array.map((item) => item.fundcode);
                    const fundDetailRes = await fundApi.getFundLists({
                        fundcodelist: fundCodeList,
                        fundclass: "*",
                        pagesize: array.length,
                        pagenum: 1
                    });

                    if (fundDetailRes.data && fundDetailRes.data.list) {
                        // 创建基金代码到详细信息的映射
                        const fundDetailMap = {};
                        fundDetailRes.data.list.forEach((detail) => {
                            fundDetailMap[detail.fundcode] = detail;
                        });

                        // 合并 tradingmethod 字段到基金数据
                        array.forEach((fund) => {
                            if (fundDetailMap[fund.fundcode]) {
                                fund.tradingmethod = fundDetailMap[fund.fundcode].tradingmethod;
                            }
                        });
                    }
                }

                array.forEach((fund, index) => {
                    fund.isBuy = this.$util.checkBuy(fund);
                    fund.isSell = this.$util.checkSell(fund);
                    fund.isChange = this.$util.checkChange(fund);
                    fund.isCurrency = this.$util.checkGeneral(fund);
                });
                // 购买渠道选择了“全部”，且该客户存在直销+代销资产数据时
                const hasFlag1 = array.some((item) => item.sourceflag == "1");
                const hasFlag2 = array.some((item) => item.sourceflag == "2");
                this.dataPromptShow =
                    !this.sourceflag && hasFlag1 && hasFlag2 && this.showprofitexplain;
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                }
                this.assets = array;
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, array);
                }
            }
        },
        // 搜索资产
        searchAssets() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 切换资产类型
        selectType(index) {
            if (this.selectIndex != index) {
                this.selectIndex = index;
                this.pageoffset = 1;
                if (index == 0) {
                    // 全部产品
                    this.assetshowtype = 0;
                } else if (index == 1) {
                    // 钱柜产品
                    this.assetshowtype = 1;
                } else if (index == 2) {
                    // 普通产品
                    this.assetshowtype = 2;
                } else {
                    // 资产组合
                    this.$refs.comboAssets.getAssets();
                    return;
                }
                this.doAction();
            }
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        },
        // 跳转到详情
        showDetail(item) {
            sessionStorage.setItem("_currentAsset", JSON.stringify(item));
            this.$router.push("/assetsDetail");
            this.$router.push({
                path: "/assetsDetail",
                query: {
                    sourceflag: this.sourceflag
                }
            });
        },
        // 点击申购或赎回按钮
        async callbackFn(way, fund) {
            if (
                way == "20,22" &&
                this.$util.checkPersonalBuyBusinessDisabled(
                    fund.assetshowtype == "1" ? "充值" : fund.status == "1" ? "认购" : "申购"
                )
            ) {
                return;
            }
            let moduleId = "";
            let flag = "0";
            if (way == "24" || way == "25") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 不允许进入交易页面交易
            // 未认证投资者限制交易弹窗业务类型需要根据综合理财勾选的限制业务来提示
            const limitFlag = await this.$util.shouldShowCertificateDialog("0" + moduleId);
            if (limitFlag) {
                this.certDialogType = "callback";
                this.certDialogCopywritingDisplay = true;
                this.showDialog = true;
                return;
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            this.sdxFundInfo = {};
            const _this = this;
            if (way === "24" || way === "25") {
                let _url = "sellfund";
                if (way === "25") {
                    _url = "orderselllist";
                }
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                sessionStorage.setItem("_currentAsset", JSON.stringify(fund));
                // 现金宝取现
                if (fund.assetshowtype == "1") {
                    _url = "currencyredemption";
                }
                this.$router.push({ name: _url, query: { fundcode: fund.fundcode } });
            } else {
                // 购买
                if (way === "20,22") {
                    // 普通购买
                    fund.proto = "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            const isNeedSdxCheck = this.$util.isNeedSdxCheck(fund);
                            if (!isNeedSdxCheck) {
                                // 现金宝充值
                                if (fund.assetshowtype == "1") {
                                    this.$router.push({
                                        name: "currencycharge",
                                        query: { fundcode: fund.fundcode }
                                    });
                                } else {
                                    fund.way = way; // 添加 way 字段，供 buyCompDC.vue 计算 isPwdCheck
                                    let _url = "buyfund";
                                    this.$util.grantTradeSdxAccessAndStoreFund(_url, fund);
                                    this.$router.push({
                                        name: _url,
                                        query: { fundcode: fund.fundcode }
                                    });
                                }
                                return;
                            }
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    this.sdxFundInfo = _x;
                                    // 现金宝充值
                                    if (this.sdxFundInfo.assetshowtype == "1") {
                                        this.$router.push({
                                            name: "currencycharge",
                                            query: { fundcode: this.sdxFundInfo.fundcode }
                                        });
                                    } else {
                                        this.sdxDialogVisible = true;
                                        this.controlPopups();
                                    }
                                }
                            });
                        }
                    });
                }
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            let _url = "buyfund";
            // // 现金宝充值
            // if (this.sdxFundInfo.assetshowtype == "1") {
            //     _url = "currencycharge";
            // }
            this.$util.grantTradeSdxAccessAndStoreFund(_url, this.sdxFundInfo);
            this.$router.push({
                name: _url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        },
        // 登录后弹窗-银行卡
        bankCardListCheck(list) {
            this.bankCardNum = list.filter((item) => !item.activeDisabledTip).length;
            const showBankCard = sessionStorage.getItem("_showBankCard");
            this.shouldShowBankCard =
                this.bankCardNum > 0 &&
                !showBankCard &&
                this.$cache.getUserOtherInfo().specialflag == "0" &&
                this.$util.getConfig().hideFunc &&
                !this.$util.isPersonalBuyBusinessDisabled();
            return this.shouldShowBankCard;
        },
        bankCardListClose() {
            this.bankCardVisible = false;
            sessionStorage.setItem("_showBankCard", "1");
            if (this.queueResolveStep4) {
                this.queueResolveStep4();
                this.queueResolveStep4 = null;
            }
        },
        bankCardListHandle() {
            this.bankCardVisible = false;
            sessionStorage.setItem("_showBankCard", "1");
            if (this.queueResolveStep4) {
                this.queueResolveStep4();
                this.queueResolveStep4 = null;
            }
            this.$router.push({ name: "acctManager", query: { activeIndex: "4-1" } });
        },
        // 证件上传弹窗关闭/确认时通知队列继续
        handleCertDialogClosed() {
            if (this.certDialogType === "queue") {
                // 队列引导场景：写入 isDialogShown，resolve 队列
                sessionStorage.setItem("isDialogShown", "true");
                if (this.certDialogResolver) {
                    this.certDialogResolver();
                    this.certDialogResolver = null;
                }
            }
            // 重置弹窗状态
            this.showDialog = false;
            this.certDialogType = "";
            this.certDialogCopywritingDisplay = true;
        },
        // 登录后弹窗-身份证生位
        idCardHolderCheck() {
            const info = this.$cache.getUser();
            if (
                info.certificatetype == "00" &&
                info.certificateno_eighteen &&
                info.certificateno_eighteen.length == 18
            ) {
                const showIdCardHolder = sessionStorage.getItem("_showIdCardHolder");
                this.shouldShowIdCardHolder = !showIdCardHolder;
                return this.shouldShowIdCardHolder;
            }
            this.shouldShowIdCardHolder = false;
            return false;
        },
        idCardHolderClose() {
            this.idCardHolderVisible = false;
            sessionStorage.setItem("_showIdCardHolder", "1");
            if (this.queueResolveStep5) {
                this.queueResolveStep5();
                this.queueResolveStep5 = null;
            }
        },
        async idCardHolderHandle() {
            // 用户确认：关闭“升位提示”，并告知队列后续走 direct 还是 ocr
            this.idCardHolderVisible = false;
            sessionStorage.setItem("_showIdCardHolder", "1");

            const accountInfo = this.$cache.getParamValue("account_info");
            const needocrbiz =
                accountInfo && accountInfo.needocrbiz
                    ? accountInfo.needocrbiz.includes("certupgrade")
                    : false;
            // 判断系统是否支持身份证（证件类型 00）OCR 识别。
            const ocrSysFlag = this.$cache.isOcrCertTypeSupported("00");

            if (!ocrSysFlag) {
                this.idUpgradeOcrRequired = false;
                this.idUpgradePath = "unsupported";
            } else {
                this.idUpgradeOcrRequired = needocrbiz;
                this.idUpgradePath = this.idUpgradeOcrRequired ? "ocr" : "direct";
            }
            this.idUpgradeOcrSuccess = false;
            this.idUpgradeCompletedInQueue = false;

            if (this.idUpgradePath === "unsupported") {
                this.idCardHolderUnsupportedVisible = true;
                return;
            }

            if (this.queueResolveStep5) {
                this.queueResolveStep5();
                this.queueResolveStep5 = null;
            }
        },
        idCardHolderUnsupportedClose() {
            this.idCardHolderUnsupportedVisible = false;
            if (this.queueResolveStep5) {
                this.queueResolveStep5();
                this.queueResolveStep5 = null;
            }
        },
        // 登录后弹窗-身份证生位完成
        idCardHolderCompletedClose() {
            this.idCardHolderCompletedVisible = false;
            if (this.queueResolveStep7) {
                this.queueResolveStep7();
                this.queueResolveStep7 = null;
            }
        },
        idCardHolderCompletedHandle() {
            this.idCardHolderCompletedVisible = false;
            if (this.queueResolveStep7) {
                this.queueResolveStep7();
                this.queueResolveStep7 = null;
            }
            this.$router.push({ name: "idnumbertran" });
        },
        appropriateHandlingVisibleClose() {
            this.appropriateHandlingVisible = false;
            this.warnVisible = false;
            sessionStorage.setItem("_showWarn", "1");
            if (this.queueResolveStep3) {
                this.queueResolveStep3();
                this.queueResolveStep3 = null;
            }
        },
        // 控制弹框的优先级（非首页队列逻辑，仅用于交易/弹窗互斥的老逻辑）
        controlPopups() {
            if (this.idCardHolderVisible) {
                this.bankCardVisible = false;
                this.sdxDialogVisible = false;
                this.warnVisible = false;
                sessionStorage.setItem("_showWarn", "");
                sessionStorage.setItem("_showBankCard", "");
                sessionStorage.setItem("_showIdCardHolder", "");
            }
        },
        async imgUp(flag) {
            if (flag) {
                // OCR 成功后：先更新用户信息，再通知队列“第6步完成”
                this.ocrProcessing = true;

                const info = this.$cache.getUser();
                const params = Object.assign({}, info);
                params.certificateno = flag.certificateno;
                const validdate = flag.vailddate || flag.validdate;
                if (validdate) {
                    params.validdate =
                        validdate === "长期" || validdate === "长期有效"
                            ? "99991231"
                            : this.$util.normalizeOcrDate(validdate);
                    params.validtype = params.validdate === "99991231" ? 1 : 0;
                }
                delete params.en_certificateno;

                try {
                    const res = await userApi.updAcctInfo(params, false, true);
                    if (res && res.data && res.data.appsheetserialno) {
                        await new Promise((resolve) => {
                            this.$cache.refreshUser(() => resolve());
                        });
                        this.idUpgradeOcrSuccess = true;
                    } else {
                        this.idUpgradeOcrSuccess = false;
                    }
                } finally {
                    this.ocrProcessing = false;

                    if (this.queueResolveStep6) {
                        this.queueResolveStep6();
                        this.queueResolveStep6 = null;
                    }
                }
            }
        },
        regression() {
            this.ocrShow = false;
            // OCR 取消/关闭：如果没有进入成功处理流程，则直接通知队列第6步结束
            if (this.queueResolveStep6 && !this.ocrProcessing) {
                this.queueResolveStep6();
                this.queueResolveStep6 = null;
            }
        },
        // direct path：直接升位接口调用 + 用户刷新
        async performDirectIdUpgrade() {
            const info = this.$cache.getUser();
            if (!info || !info.en_certificateno_eighteen) return false;

            const nextInfo = Object.assign({}, info);
            nextInfo.en_certificateno = nextInfo.en_certificateno_eighteen;

            try {
                const res = await userApi.updAcctInfo(nextInfo);
                if (res && res.data && res.data.appsheetserialno) {
                    await new Promise((resolve) => {
                        this.$cache.refreshUser(() => resolve());
                    });
                    return true;
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("[performDirectIdUpgrade] error:", e);
            }
            return false;
        },
        // 判断当前是否仍需要身份证升位
        isIdUpgradeNeeded() {
            const info = this.$cache.getUser();
            return (
                info &&
                info.certificatetype == "00" &&
                info.certificateno_eighteen &&
                info.certificateno_eighteen.length == 18
            );
        },
        // 第8步：投资者回访弹窗
        async showReturnVisitDialog() {
            const h = this.$createElement;
            try {
                await this.$msgbox({
                    title: "投资者回访",
                    message: h("p", null, [
                        h("p", null, "尊敬的投资者: "),
                        h(
                            "span",
                            { style: "margin-left: 20px" },
                            "根据《证券期货投资者适当性管理办法》关于定期对投资者开展回访的规定，诚邀您参与本次投资者回访调研工作，感谢您的支持!"
                        )
                    ]),
                    showCancelButton: true,
                    confirmButtonText: "现在参与",
                    cancelButtonText: "暂不"
                });

                const res = await userApi.upReturnVisitStatus({ returnStatus: "1" });
                if (res && res.code == "0") {
                    window.open(this.$cache.getCompanyInfoParam("10102036"), "_blank");
                }
            } catch (e) {
                // cancel：不处理
            }
        },
        handleCloseDialog() {
            this.appropriateHandlingVisible = false;
            this.warnVisible = false;
            sessionStorage.setItem("_showWarn", "1");
            if (this.queueResolveStep3) {
                this.queueResolveStep3();
                this.queueResolveStep3 = null;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.assets-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 15px 0;

    .title-line {
        width: 3px;
        height: 16px;
        background: var(--color-primary);
        border-radius: 2px;
        margin-right: 8px;
    }

    .title-content {
        font-size: 16px;
        font-weight: 500;
        color: var(--color-text-primary);
        margin-right: 12px;
    }

    .deadline-text {
        font-size: 14px;
        color: var(--color-text-accent);
        line-height: 25px;
    }
    .select-class {
        font-size: 14px;
        padding: 5px 15px;
        vertical-align: middle;
    }
    .assets-search {
        padding: 5px 0;
        .input-search {
            width: 350px;
            vertical-align: middle;
            .search-icon {
                margin: 3px 5px;
                color: var(--color-text-accent);
            }
            .el-input__inner {
                height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
    }
    .asset-proof-button {
        width: 100px;
        height: 40px;
        margin-left: 12px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
    }
    .second-button {
        background: #f8f8f8;
        color: $text-color1;
        border-radius: 4px;
        border: 1px solid #eaeaea;
    }
}

.my-dialog-contain {
    .acct-con {
        padding: 40px 40px 20px;
        :deep(.el-form-item__label) {
            width: 90px;
            text-align: right;
            padding: 0;
            color: #999;
        }
        .form-text {
            .input-pwd {
                margin-left: 10px;
                width: 416px;
            }
        }
        .btn-contain {
            text-align: center;
            margin-top: 30px;
            .confirm-btn {
                width: 180px;
                height: 42px;
                border-radius: 2px;
                background: var(--color-primary);
                border: 1px solid var(--color-primary);
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                cursor: pointer;
            }
        }
    }
    .no-asset-content {
        padding: 40px 20px;
        text-align: center;
        font-size: 16px;
        color: var(--color-text-regular);
        line-height: 1.6;
    }
    .noAssetDialogVisible-footer {
        width: 180px;
        margin: 0 auto;
        button {
            width: 180px;
        }
    }
}

.holding-title {
    display: flex;
    align-items: center;
    margin: 20px 0 15px 0;

    .title-line {
        width: 3px;
        height: 16px;
        background: var(--color-primary);
        border-radius: 2px;
        margin-right: 8px;
    }

    .title-content {
        font-size: 16px;
        font-weight: 500;
        color: var(--color-text-primary);
    }
}

.warn-info {
    background: var(--color-accent);
    box-sizing: border-box;
    border: 1px solid var(--color-divided);
    padding: 12px 15px;
    display: flex;
    .warn-icon {
        margin-top: 4px;
        color: var(--color-primary);
    }
    .warn-content {
        margin-left: 5px;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-text-regular);
        .warn-tip {
            color: var(--color-primary);
        }
        .deal-btn {
            color: var(--color-redirect);
            cursor: pointer;
        }
    }
}

.warn-detail {
    padding: 50px 20px;
    font-size: 16px;
    text-align: center;
}

.asset-type {
    display: flex;
    padding: 16px 0px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;

    .type-normal {
        width: 120px;
        height: 40px;
        border-radius: 25px;
        background: var(--color-bg-container);
        color: var(--color-text-regular);
        margin-right: 30px;
        cursor: pointer;
    }
    .type-select {
        width: 120px;
        height: 40px;
        border-radius: 25px;
        background: var(--color-primary);
        color: var(--color-text-white);
        margin-right: 30px;
        cursor: pointer;
    }
}
.btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
}
.line {
    background: var(--color-divided);
    width: 1px;
    height: 12px;
}
.fund-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    .xjbStyle {
        border: 1px solid var(--color-primary);
        color: var(--color-primary) !important;
        padding: 2px 5px;
    }
}
.el-table td.el-table__cell div {
    color: var(--color-text-primary);
}
.el-table td.el-table__cell span {
    color: var(--color-text-primary);
    &.add {
        color: var(--color-up);
    }
    &.reduce {
        color: var(--color-down);
    }
}
.el-table {
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 20px;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}
.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: var(--color-redirect);
}
.el-button--text.is-disabled {
    color: var(--color-text-accent);
}
.page-box {
    padding: 0;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
